export function formatNumberWithSpaces(num: number | string): string {
  const parts = num.toString().split('.')
  const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
  const formattedNumber = parts[1] ? `${integerPart}.${parts[1]}` : integerPart
  return num.toString().includes('.')
    ? Number(formattedNumber).toFixed(3)
    : formattedNumber
}
